import styled from "styled-components";

const NomText = styled.span`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
  overflow-wrap: break-word;
  line-height: 1.3;
  min-width: 0;
  width: 100%;
`;

/**
 * Nom column body: up to two lines in compact density, ellipsis at end when truncated.
 */
export default function NomCellContent({ children, title }) {
  const text = children == null || children === "" ? "—" : children;
  const tip = typeof text === "string" ? text : undefined;
  return <NomText title={title ?? tip}>{text}</NomText>;
}
